<template>
    <div class="hidden md:block">
        <div class="border-gray-325 bg-white shadow">
            <div class="mb-2 p-4 text-[16px] font-semibold text-gray-900">
                Additional Quizzes
            </div>
            <table class="w-full">
                <thead
                    class="text-left text-[14px] font-semibold text-gray-625"
                >
                    <th class="min-w-[150px] p-2 pl-4">Type</th>
                    <th class="p-2">Description</th>
                    <th class="p-2"></th>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            !$page.props.auth.user
                                .has_taken_student_assessment_quiz
                        "
                        class="border-t border-gray-325 odd:bg-gray-50"
                    >
                        <td class="p-2 pl-4 text-[16px] font-semibold">
                            <text-clamp
                                autoResize
                                :max-lines="1"
                                text="Initial Assessment"
                            >
                            </text-clamp>
                        </td>

                        <td class="p-2 text-[15px] font-medium text-gray-625">
                            A 50-question quiz to help us tailor your studying
                            to your weak points
                        </td>
                        <td class="p-2 text-right text-[15px]">
                            <student-take-quiz-button
                                quiz-type="assessment"
                                button-css="ml-4 inline-block rounded border border-primary-525 px-2 py-2 text-center text-[15px] text-primary-525 hover:cursor-pointer hover:bg-primary-525 hover:text-white"
                            />
                        </td>
                    </tr>
                    <tr class="border-t border-gray-325 odd:bg-gray-50">
                        <td class="p-2 pl-4 text-[16px] font-semibold">
                            <text-clamp
                                autoResize
                                :max-lines="1"
                                text="Random Quiz"
                            >
                            </text-clamp>
                        </td>

                        <td class="p-2 text-[15px] font-medium text-gray-625">
                            A 10-question quiz consisting of random questions
                        </td>
                        <td class="p-2 text-right text-[15px]">
                            <student-take-quiz-button
                                quiz-type="random"
                                button-css="ml-4 inline-block rounded border border-primary-525 px-2 py-2 text-center text-[15px] text-primary-525 hover:cursor-pointer hover:bg-primary-525 hover:text-white"
                            />
                        </td>
                    </tr>
                    <tr class="border-t border-gray-325 odd:bg-gray-50">
                        <td class="p-2 pl-4 text-[16px] font-semibold">
                            <text-clamp
                                autoResize
                                :max-lines="1"
                                text="Targeted Quiz"
                            >
                            </text-clamp>
                        </td>

                        <td class="p-2 text-[15px] font-medium text-gray-625">
                            A 10-question quiz focused on topic areas you
                            struggle with most
                        </td>
                        <td class="p-2 text-right text-[15px]">
                            <student-take-quiz-button
                                quiz-type="targeted"
                                button-css="ml-4 inline-block rounded border border-primary-525 px-2 py-2 text-center text-[15px] text-primary-525 hover:cursor-pointer hover:bg-primary-525 hover:text-white"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="md:hidden">
        <div
            class="mb-4 rounded border border-gray-325 bg-white p-3"
            v-if="!$page.props.auth.user.has_taken_student_assessment_quiz"
        >
            <div class="mb-4 flex justify-between gap-4">
                <div class="">
                    <div class="font-semibold text-gray-800">
                        <text-clamp
                            autoResize
                            :max-lines="1"
                            text="Initial Assessment"
                        >
                        </text-clamp>
                    </div>
                    <div class="text-gray-625">
                        A 50-question quiz to help us tailor your studying to
                        your weak points
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-2">
                <student-take-quiz-button
                    quiz-type="assessment"
                    button-css="w-full rounded bg-primary-525 p-2 text-center text-[16px] font-medium text-white hover:cursor-pointer hover:bg-primary-600"
                />
            </div>
        </div>
        <div class="mb-4 rounded border border-gray-325 bg-white p-3">
            <div class="mb-4 flex justify-between gap-4">
                <div class="">
                    <div class="text-[17px] font-semibold text-gray-800">
                        <text-clamp
                            autoResize
                            :max-lines="1"
                            text="Random Quiz"
                        >
                        </text-clamp>
                    </div>
                    <div class="text-gray-625">
                        A 10 question quiz consisting of random questions
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-2">
                <student-take-quiz-button
                    quiz-type="random"
                    button-css="w-full rounded bg-primary-525 p-2 text-center text-[16px] font-medium text-white hover:cursor-pointer hover:bg-primary-600"
                />
            </div>
        </div>
        <div class="mb-4 rounded border border-gray-325 bg-white p-3">
            <div class="mb-4 flex justify-between gap-4">
                <div class="">
                    <div class="font-semibold text-gray-800">
                        <text-clamp
                            autoResize
                            :max-lines="1"
                            text="Targeted Quiz"
                        >
                        </text-clamp>
                    </div>
                    <div class="text-gray-625">
                        A 10-question quiz focused on topic areas you struggle
                        with most
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-2">
                <student-take-quiz-button
                    quiz-type="targeted"
                    button-css="w-full rounded bg-primary-525 p-2 text-center text-[16px] font-medium text-white hover:cursor-pointer hover:bg-primary-600"
                />
            </div>
        </div>
    </div>
</template>
<script>
import StudentTakeQuizButton from "@/Components/StudentTakeQuizButton.vue";

export default {
    name: "StudentQuizzesAdditionalQuizTypesTable",
    components: { StudentTakeQuizButton },
};
</script>
